import { VacationRentalAmenityKindEnum } from "redmond";

export const AMENITIES_SELECTION_HEADING_TEXT = "Amenities";

export const AMENITY_LABELS = {
  [VacationRentalAmenityKindEnum.PetFriendly]: "Pet friendly",
};
